var render, staticRenderFns
import script from "./PointMarker.vue?vue&type=script&lang=js&"
export * from "./PointMarker.vue?vue&type=script&lang=js&"
import style0 from "./PointMarker.vue?vue&type=style&index=0&id=5037417e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports